module.exports = "/static/assets/7d7e616c9bac2ac2f8c45521918e769e.png";